import { render, staticRenderFns } from "./formulsFraction.vue?vue&type=template&id=0e5cf702&scoped=true"
import script from "./formulsFraction.vue?vue&type=script&lang=js"
export * from "./formulsFraction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5cf702",
  null
  
)

export default component.exports